module.exports = __webpack_public_path__ + "img/10.04f13236.png";